import { ManualAdjustments, expected } from '@aloft/toolkit-shared';
import { EntityState, PayloadAction } from '@reduxjs/toolkit';

import { cloneDeep } from 'lodash';

import { CompPropertyDataState, PropertyDataState, SubjectPropertyDataState } from '../../types.ts';
import { propertyDataAdapter } from '../propertyDataAdapter.ts';
import { getBumpedSyncState } from '../utils/getBumpedSyncState.ts';

export const setManualAdjustmentsReducer = (
  state: EntityState<PropertyDataState, string>,
  action: PayloadAction<{ id: string; changes: ManualAdjustments }[]>,
) => {
  const newEntities: { id: string; changes: Partial<PropertyDataState> }[] = action.payload.map(
    ({ id, changes }) => {
      const clonedManualAdjustments = cloneDeep(changes);

      const current = expected(state.entities[id]);
      const syncState = getBumpedSyncState(current.syncState);

      if (current.id === 'subject') {
        return {
          id,
          changes: {
            syncState,
            subjectData: {
              ...(current as SubjectPropertyDataState).subjectData,
              editableData: {
                ...(current as SubjectPropertyDataState).subjectData.editableData,
                manualAdjustments: clonedManualAdjustments,
              },
            },
          },
        };
      }

      return {
        id,
        changes: {
          syncState,
          compData: {
            ...(current as CompPropertyDataState).compData,
            editableData: {
              ...(current as CompPropertyDataState).compData.editableData,
              manualAdjustments: clonedManualAdjustments,
            },
          },
        },
      };
    },
  );

  propertyDataAdapter.updateMany(state, newEntities);
};
